import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  page: 1,
  itemsPerPage: 20,
  search: '',
  // - Start sub pages with a specific user
  // shipping history
  historyCurrentPage: 1,
  historyItemsPerPage: 10,
  // all statements
  statementsCurrentPage: 1,
  statementsItemsPerPage: 10,
  // all overweight
  overweightCurrentPage: 1,
  overweightItemsPerPage: 10,
  // invoices, reps, receipts history
  invoicesCurrentPage: 1,
  invoicesItemsPerPage: 10,
  // - End sub pages with a specific user
};

const usersSlice = createSlice({
  name: 'usersUI',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    // - Start sub pages with a specific user
    // shipping history
    setHistoryCurrentPage: (state, action) => {
      state.historyCurrentPage = action.payload;
    },
    setHistoryItemsPerPage: (state, action) => {
      state.historyItemsPerPage = action.payload;
    },
    // all statements
    setStatementsCurrentPage: (state, action) => {
      state.statementsCurrentPage = action.payload;
    },
    setStatementsItemsPerPage: (state, action) => {
      state.statementsItemsPerPage = action.payload;
    },
    // all overweight
    setOverweightCurrentPage: (state, action) => {
      state.overweightCurrentPage = action.payload;
    },
    setOverweightItemsPerPage: (state, action) => {
      state.overweightItemsPerPage = action.payload;
    },
    // invoices, reps, receipts history
    setInvoicesCurrentPage: (state, action) => {
      state.invoicesCurrentPage = action.payload;
    },
    setInvoicesItemsPerPage: (state, action) => {
      state.invoicesItemsPerPage = action.payload;
    },
    // - End sub pages with a specific user

    resetFilters: () => initialState,
  },
});

export const {
  setPage,
  setItemsPerPage,
  setSearch,
  setHistoryCurrentPage,
  setHistoryItemsPerPage,
  setStatementsCurrentPage,
  setStatementsItemsPerPage,
  setOverweightCurrentPage,
  setOverweightItemsPerPage,
  setInvoicesCurrentPage,
  setInvoicesItemsPerPage,
  resetFilters,
} = usersSlice.actions;
const allUsersReducer = usersSlice.reducer;
export default allUsersReducer;
